import { FileDownload } from '@/types/request';
import { downloadFile } from '../fileDonwloadEndpoint';

export const downloadFileService = async (params: FileDownload) => {
  return await downloadFile(params);
};
